import React from "react";
//import { Link, useNavigate } from "react-router-dom";
//import { formatUrl } from "../../util/format-url";

export default function NotFoundPage(props: any) {
  //let navigate = useNavigate();
  const { url, suggestions } = props;
  const selectSuggestion = (url: string) => {
    const winUrl: any = window.location;
    //console.log("selectSuggestion", winUrl, url);
    document.location.href = `${winUrl.origin}${url}`;
    //navigate(url);
  };
  return (
    <>
      <div className="no-content-found">
        <div className="no-content-found-inner">
          <div className="no-content-found-title">Whoops</div>
          <div className="no-content-found-subtitle">
            404. There's nothing here...
          </div>
          <div className="no-content-found-details">
            The page you are looking for{" "}
            <i className="no-content-found-url">{`/${url}`}</i> is
            {"  "}
            not found
          </div>
          {suggestions && suggestions.length > 0 && (
            <div className="no-content-found-suggestions">
              <div className="no-content-found-suggestions-title">
                Were you looking for one of these...
              </div>
              {suggestions.map((page: any) => (
                <div
                  className={`no-content-suggestion-link`}
                  key={`no-content-suggestion-link-${page.url}`}
                  onClick={(e: any) => {
                    selectSuggestion(page.url);
                  }}
                >
                  {page.name}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
